import {
  GET_DIET,
  CREATE_DIET,
  UPDATE_DIET,
  DELETE_DIET,
} from "../actions/types";

const initialState = {
  dietList: [],
  hospitalID: null,
  dietSaveStatus: null,
  dietUpdateStatus: null,
  dietDeleteStatus: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_DIET:
      return {
        ...state,
        dietList: action.payload.data,
        hospitalID: action.hospitalID,
      };

    case CREATE_DIET:
      return {
        ...state,
        dietSaveStatus: action.payload.success,
      };

    case UPDATE_DIET:
      return {
        ...state,
        dietUpdateStatus: action.payload.success,
      };

    case DELETE_DIET:
      return {
        ...state,
        dietDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}